import React from "react";
import PropTypes from "prop-types";
import Editor from "../../Editor/Editor";
import { USERROLE } from "../../../utils/commonConstant";

const Heading = ({
  comments,
  trackChangesComments,
  border,
  text,
  width,
  height,
  marginTop,
  marginLeft,
  elementId,
  elementProps,
  onTextChange,
  inlineFields,
  onEditorInlineFieldsChange,
  selectedElementId,
  formPreview = false,
  trackChangeDisplayBy = USERROLE.ADMIN,
  trackHistorys,
  isShowTrackHistory=false,
  forceSave=false,
  isPresentMode,
  
}) => {
  return (
    <>
      <Editor
        border={border}
        comments={comments}
        trackChangesComments={trackChangesComments}
        trackHistorys={trackHistorys}
        menuBar={border ? true : false}
        editable={border ? true : false}
        text={text}
        elementId={elementId}
        elementProps={elementProps}
        existingInlineFields={inlineFields}
        formPreview={formPreview}
        onTextChange={(value, comments, trackChangesComments, forceSave,trackHistorys) => {
            onTextChange(value, comments, trackChangesComments, forceSave,trackHistorys);
        }}
        onEditorInlineFieldsChange={onEditorInlineFieldsChange}
        selectedElementId={selectedElementId}
        trackChangeDisplayBy={trackChangeDisplayBy}
        isShowTrackHistory={isShowTrackHistory}
        isPresentMode={isPresentMode}
      />
    </>
  );
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,
  margnLeft: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
};

export default Heading;
